import { useQuery } from '@tanstack/react-query';
import { tripExtensionApi, tripExtensionKeys } from '../api/tripExtension.api';

/** Open requests change on the other party's action, so keep these fresh while visible. */
const OPEN_REQUEST_REFETCH_MS = 15_000;

export function useBookingExtensions(bookingId: string | undefined, enabled = true) {
  return useQuery({
    queryKey: tripExtensionKeys.forBooking(bookingId ?? ''),
    queryFn: () => tripExtensionApi.listForBooking(bookingId!),
    enabled: Boolean(bookingId) && enabled,
    staleTime: 0,
    refetchInterval: (query) =>
      query.state.data?.some((ext) => ext.isOpen) ? OPEN_REQUEST_REFETCH_MS : false,
  });
}

export function useExtensionOptions(bookingId: string | undefined, enabled: boolean) {
  return useQuery({
    queryKey: tripExtensionKeys.options(bookingId ?? ''),
    queryFn: () => tripExtensionApi.getOptions(bookingId!),
    enabled: Boolean(bookingId) && enabled,
    staleTime: 0,
  });
}

export function useGuidePendingExtensions() {
  return useQuery({
    queryKey: tripExtensionKeys.guidePending(),
    queryFn: tripExtensionApi.listGuidePending,
    staleTime: 0,
    refetchInterval: 30_000,
  });
}
